module.exports = __webpack_public_path__ + "img/full1-min.52d2a654.png";